import { render } from "./GetItemsModal.vue?vue&type=template&id=847ae79a"
import script from "./GetItemsModal.vue?vue&type=script&lang=js"
export * from "./GetItemsModal.vue?vue&type=script&lang=js"

import "./GetItemsModal.vue?vue&type=style&index=0&id=847ae79a&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__